 import React, { useEffect,useState } from 'react';
import { Link } from 'react-router-dom';
import ProtectedMenu from '../components/security/protected.menu';
import ProtectedSubmenu from '../components/security/protected.submenu';
import  DynamicMenuGenerate  from '../components/security/dynamic-menu-generate'
import securityService from '../components/security/security.service';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeUpdate } from '../store/slices/theme';
import { setUpdateLogo } from '../store/slices/head';
import './header.scss'
export default function Menu() {

  const [challanInvoiceInputSecurity ,setChallanInvoiceInputSecurity]  = useState([])
  const [unitOfMeasurementSecurity ,setUnitOfMeasurementSecurity]  = useState([])
  const [showVendorMenu, setShowVendorMenu] = useState(true)
  const dispatch = useDispatch();
  const reduxData = useSelector(state => state.Head);
  const [logoPreview, setLogoPreview] = useState('');
  
  const CompanyNameLogged = securityService.getCompanyNameLoggedInUserId();

  const getInitials = (name) => {
    return name ? name.charAt(0).toUpperCase() : 'C';
  };


  useEffect(() => {
    if (reduxData.updateLogo === true) {
      console.log(reduxData.updateLogo);
      dispatch(setUpdateLogo(false));
      setLogoPreview(securityService.getCompanyImage());
    }
  }, [reduxData.updateLogo ]); // Fixed dependency array

  useEffect(() => {
    
    setLogoPreview(securityService.getCompanyImage());
    const navItem = document.querySelectorAll('ul .nav-item');

    navItem.forEach((va) => {
      if (va.firstChild.classList.contains("nav-treeview")) {
        va.remove();
      }
    });

    const sidebar = document.querySelector('.sidebar');
    sidebar.style.opacity = '0';
    setTimeout(() => {
      sidebar.style.opacity = '1';
      sidebar.style.transition = 'opacity 0.3s linear';

      (async () => {
        const ok = await securityService.getShowSaleChallan();
      if(ok == true){
        // setChallanInvoiceInputSecurity([{ to: '/Setup/Invoice', name: 'Sale Invoice', displayName: 'Sale Invoice' }]);
        setChallanInvoiceInputSecurity(
          [
            { to: '/Setup/SaleInvoice', name: true, displayName: 'Sale Invoice' },
            
        ]);
        setUnitOfMeasurementSecurity([{ to: '/Setup/UnitOfMeasurement', name: true, displayName: 'Unit Of Measurement' },])
      }else{
        setChallanInvoiceInputSecurity([])
        setUnitOfMeasurementSecurity([])
      }
    })()
     
    }, 600);


  }, []);

  useEffect(() => {

    setTimeout(() => {
 
     
    (async () => {
      const ok = await securityService.getShowPurchaseChallan();
    console.log(ok)
      if(ok == true){
        setShowVendorMenu(true)  // ADD THIS

      }else{
        setShowVendorMenu(false)  // ADD THIS

      }
    })()
    }, 600);


  }, []);
  const SetupMenuItems = [
    {
      displayValue: 'SETUP',
      icon: 'fa-bars',
      menus:[
        // { to: '/Setup/Building', name: 'Building', displayName: 'Building' },
        // { to: '/ChequeStatus', name: 'Cheque Status', displayName: 'Cheque Status' },
        // { to: '/Company', name: 'Company', displayName: 'Company' },
        // { to: '/Setup/CostCenter', name: 'Cost Center', displayName: 'Cost Center' },
        // { to: '/FullProperty', name: 'Full Property', displayName: 'Full Property' },
        // { to: '/Setup/ModeOfPayment', name: 'Mode Of Payment', displayName: 'Mode Of Payment' },
        // { to: '/Setup/Nationality', name: 'Nationality', displayName: 'Nationality' },
        // { to: '/Setup/ProductCategory', name: 'Product Category', displayName: 'Product Category' },
        // { to: '/Product', name: 'Product', displayName: 'Product' },
        // { to: '/Setup/Property', name: 'Property', displayName: 'Property' },
        // { to: '/Setup/PropertyFloor', name: 'Property Floor', displayName: 'Property Floor' },
        // { to: '/Setup/PropertyLocation', name: 'Property Location', displayName: 'Property Location' },
        // { to: '/PropertyOwner', name: 'Property Owner', displayName: 'Property Owner' },


        { to: '/Buyer', name: 'Buyer', displayName: 'BUYER' },
        ...(showVendorMenu == true? [{ to: '/Vendor', name: true, displayName: 'VENDOR' }] : []),
        { to: '/Seller', name: 'Buyer', displayName: 'SELLER' },
        ...unitOfMeasurementSecurity,
        ...(showVendorMenu == true?[ {
          displayValue: 'Product',
          type: 'submenu',
          icon: 'nav-icon',
          menus: [
            { to: '/setup/ProductDescription1', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription1')}`},
        { to: '/setup/ProductDescription2', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription2')}`},
        { to: '/setup/ProductDescription3', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription3')}`},
        { to: '/setup/ProductDescription4', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription4')}`},
        { to: '/setup/ProductDescription5', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription5')}`},
        { to: '/setup/ProductDescription6', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription6')}`},
        { to: '/setup/GD', name: true, displayName: 'GD' },
        { to: '/setup/Product', name: true, displayName: 'Product' }
          ]
        }
      ]: []),
        // ...(showVendorMenu == true? [
        // { to: '/setup/ProductDescription1', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription1')}`},
        // { to: '/setup/ProductDescription2', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription2')}`},
        // { to: '/setup/ProductDescription3', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription3')}`},
        // { to: '/setup/ProductDescription4', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription4')}`},
        // { to: '/setup/ProductDescription5', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription5')}`},
        // { to: '/setup/ProductDescription6', name: true, displayName: `${securityService.getCaptionForDescriptionInputs('ProductDescription6')}`},
        // { to: '/setup/GD', name: true, displayName: 'GD' },
        // { to: '/setup/Product', name: true, displayName: 'Product' }]
        // : []),



        { to: '/UploadDataByExcel', name: 'Buyer', displayName: 'Import Data' },
        // { to: '/AdditionalPayment', name: 'Additional Payment', displayName: 'Additional Payment' },
        // { to: '/Setup/PropertyUnitType', name: 'Property Unit Type', displayName: 'Property Unit Type' },
        // { to: '/Setup/PropertyUsageType', name: 'Property Usage Type', displayName: 'Property Usage Type' },
         
        

      ]
    }
  ];
  const DashboardMenu = [
    {
      displayValue: 'Dashboard',
      icon: 'fa-tachometer-alt',
      menus:[
        { to: '/home', name: 'Dashboard', displayName: 'Dashboard' },
      ]
    }
  ];
const ContractsMenu = [
    {
      displayValue: 'Contracts',
      icon: 'fa-bars',
      menus:[
        { to: '/TenantContractFS', name: 'Tenant Contract FS', displayName: 'Tenant Contract FS' },
        { to: '/TenantContractPM', name: 'Tenant Contract PM', displayName: 'Tenant Contract PM' },
      ]
    }
  ];

  const InvoiceMenu = [
    {
      displayValue: 'FBR Invoices',
      icon: 'fa-file-invoice',
      menus:[
        { to: '/SaleInvoice', name: 'Sale Invoice', displayName: 'Sale Invoice' },
        { to: '/SaleInvoiceSandbox', name: 'Sale Invoice Sandbox', displayName: 'Sale Invoice Sandbox' },
        { to: '/SaleInvoicePosted', name: 'Sale Invoice', displayName: 'Sale Invoice Posted' },
        { to: '/PurchaseInvoice', name: 'Purchase Invoice', displayName: 'Purchase Invoice' },
        { to: '/IssueInvoice', name: 'Issue Invoice', displayName: 'Issue Invoice' },
      ]
    }
  ];
  
  const ChallanInvoiceMenu = [
    {
      displayValue: 'Invoices',
      icon: 'fa-file-invoice',
      menus:[
        // { to: '/IssueInvoice', name: 'Sale Invoice', displayName: 'Issue Invoice' },
        ...challanInvoiceInputSecurity,
        ...(showVendorMenu == true? [{ to: '/Setup/PurchaseInvoice', name: true, displayName: 'Purchase Invoice' }] : [])
      ]
    }
  ];

  

  const SecurityMenu = [
    {
      displayValue: 'Security',
      icon: 'fa-sitemap',
      menus:[
        // { to: '/UsersInfo', name: 'User Information', displayName: 'Users Info' },
        { to: '/Security/ChangePassword', name: 'Sale Invoice', displayName: 'Change Password' },
        // { to: '/Security/ChangeAccess', name: 'User Rights', displayName: 'Change Access' },
      ]
    }
  ];

  // const FinanceMenu = [
  //   {
  //     displayValue: 'Finance',
  //     icon: 'fa-address-card',
  //     Submenu: [
  //       {
  //         displayValue: 'Receipt Voucher',
  //         type: 'submenu',
  //         icon: 'nav-icon',
  //         menus: [
  //           { to: '/Voucher/RV/Detail', name: 'Receipt Voucher', displayName: 'Detail' },
  //           { to: '/Voucher/RV/Summary', name: 'Receipt Voucher', displayName: 'Summary' }
  //         ]
  //       },
  //       {
  //         displayValue: 'Payment Voucher',
  //         type: 'submenu',
  //         icon: 'nav-icon',
  //         menus: [
  //           { to: '/Voucher/PV/Detail', name: 'Payment Voucher', displayName: 'Detail' },
  //           { to: '/Voucher/PV/Summary', name: 'Payment Voucher', displayName: 'Summary' }
  //         ]
  //       },

  //       {
  //         displayValue: 'Journal Voucher',
  //         type: 'submenu',
  //         icon: 'nav-icon',
  //         menus: [
  //           { to: '/Voucher/JV/Detail', name: 'Journal Voucher', displayName: 'Detail' },
  //           { to: '/Voucher/JV/Summary', name: 'Journal Voucher', displayName: 'Summary' }
  //         ]
  //       }
  //     ] 
  //   }
  // ];
  
  const AccountsMenu = [
    {
      displayValue: 'Accounts',
      icon: 'fa-sitemap',
      menus:[
        // { to: '/Setup/Brand', name: 'User Information', displayName: 'Accounts' },
        { to: '/ChartOfAccount', name: 'Chart Of Account', displayName: 'Chart Of Account' },
        { to: '/ReceivableAccounts', name: 'Receivable Accounts', displayName: 'Receivable Accounts' },
        { to: '/AgentAccounts', name: 'Agent Accounts', displayName: 'Agent Accounts' },
      ] 
    }
  ]; 



  
  return (
    <div>
      <aside className='main-sidebar sidebar-light-success elevation-4'>
        <div className='sidebar'>

          {/* COMPANY HEADER - Professional Layout */}
<div className="company-header d-flex align-items-center p-2 mb-2 border-secondary">
  {/* LEFT SIDE - Circular Logo (Vertically Centered) */}
  <div className="flex-shrink-0 mr-2">
    {logoPreview ? (
      <div className="logo-wrapper">
        <img 
          src={logoPreview} 
          alt={CompanyNameLogged}
          className="company-logo rounded-circle border border-2 border-white shadow-sm"
          style={{ 
            width: '40px', 
            height: '40px', 
            objectFit: 'cover',
            backgroundColor: '#fff'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        {/* Fallback if image fails to load */}
        <div 
          className="logo-fallback rounded-circle bg-success d-none align-items-center justify-content-center text-white font-weight-bold shadow-sm"
          style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}
        >
          {getInitials(CompanyNameLogged)}
        </div>
      </div>
    ) : (
      <div 
        className="rounded-circle bg-success d-flex align-items-center justify-content-center text-white font-weight-bold border border-2 border-white shadow-sm"
        style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}
      >
        {getInitials(CompanyNameLogged)}
      </div>
    )}
  </div>

  {/* RIGHT SIDE - Company Name (Vertically Centered) */}
  <div className="flex-grow-1" style={{ minWidth: 0 }}>
    <h6 
      className="form-control-sidebar company-name mb-0 font-weight-bold text-white "
      style={{ 
        lineHeight: 1.2, 
        fontSize: '0.95rem',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        hyphens: 'auto',
        background:'none',
        border:'none'
      }}
      title={CompanyNameLogged}
    >
      {CompanyNameLogged || 'Company Name'}
    </h6>
  </div>
</div>

        {/* SEARCH BAR - Existing Code */}
        <div className='form-inline'>
            <div className='input-group' data-widget='sidebar-search'>
              <input
                className='form-control form-control-sidebar'
                type='search'
                placeholder='Search'
                aria-label='Search'
              />
              <div className='input-group-append'>
                <button className='btn btn-sidebar'>
                  <i className='fas fa-search fa-fw' />
                </button>
              </div>
            </div>
          </div>

          <nav className='mt-2'>
            <ul className='nav nav-pills nav-sidebar flex-column' data-widget='treeview' role='menu' data-accordion='false'>

          
          <DynamicMenuGenerate menuItems={DashboardMenu} />
          <DynamicMenuGenerate menuItems={SetupMenuItems} />
          <DynamicMenuGenerate menuItems={ContractsMenu} />
          {/* <DynamicMenuGenerate menuItems={ChallanInvoiceMenu} /> */}

          {(challanInvoiceInputSecurity?.length > 0 || showVendorMenu) && (
  <li className='nav-item'>
    <ProtectedSubmenu
      displayValue='Invoices'
      type='mainmenu'
      names={[true]}        
      icon='fa-file-invoice'
    />
    <ul className='nav nav-treeview'>
      {challanInvoiceInputSecurity.map((menu, index) => (
        <ProtectedMenu
          key={index}
          to={menu.to}
          name={true}
          displayName={menu.displayName}
        />      
      ))}

      {showVendorMenu && (
        <ProtectedMenu
          to='/Setup/PurchaseInvoice'
          name={true}
          displayName='Purchase Invoice'
        />
      )}
    </ul>
  </li>
)}


          <DynamicMenuGenerate menuItems={InvoiceMenu} />
          <DynamicMenuGenerate menuItems={SecurityMenu} />
          {/* <DynamicMenuGenerate menuItems={FinanceMenu} /> */}
          <DynamicMenuGenerate menuItems={AccountsMenu} />



              {/* SETUP MENU START */}
              {/* <li className='nav-item'>
                <ProtectedSubmenu
                  displayValue='Setup'
                  names={[
                    'Agent Accounts',
                    'Building',
                    'Company',
                    'Cost Center',
                    'Product Category',
                    'Full Property',
                    'Mode Of Payment',
                    'Nationality',
                    'Product',
                    'Property',
                    'Property Floor',
                    'Property Location',
                    'Property Owner',
                    'Additional Payment',
                    'Property Unit Type',
                    'Property Usage Type',
                    'Receivable Accounts',
                    'TenantContractFS',
                    "ChequeStatusList",
                    "SaleInvoiceList",
                    "PurchaseInvoiceList",
                    "IssueInvoiceList"
                  ]}
                  type='mainmenu'
                  icon='fa-bars'
                />
                <ul className='nav nav-treeview'>
                  <ProtectedMenu to='/setup/AgentAccounts' name='AgentAccounts' displayName='Agent Accounts' />
                  <ProtectedMenu to='/Setup/Building' name='Building' displayName='Building' />
                  <ProtectedMenu to='/ChequeStatus' name='Tenant Contract FS' displayName='Cheque Status' />
                  <ProtectedMenu to='/Company' name='Company' displayName='Company' />
                  <ProtectedMenu to='/Setup/CostCenter' name='Cost Center' displayName='Cost Center' />
                  <ProtectedMenu to='/FullProperty' name='Full Property' displayName='Full Property' />
                  <ProtectedMenu to='/Setup/ModeOfPayment' name='Mode Of Payment' displayName='Mode Of Payment' />
                  <ProtectedMenu to='/Setup/Nationality' name='Nationality' displayName='Nationality' />
                  <ProtectedMenu to='/Setup/ProductCategory' name='Product Category' displayName='Product Category' />
                  <ProtectedMenu to='/Product' name='Product' displayName='Product' />
                  <ProtectedMenu to='/Setup/Property' name='Property' displayName='Property' />
                  <ProtectedMenu to='/Setup/PropertyFloor' name='Property Floor' displayName='Property Floor' />
                  <ProtectedMenu to='/Setup/PropertyLocation' name='Property Location' displayName='Property Location' />
                  <ProtectedMenu to='/PropertyOwner' name='Property Owner' displayName='Property Owner' />
                  <ProtectedMenu to='/AdditionalPayment' name='Additional Payment' displayName='Additional Payment' />
                  <ProtectedMenu to='/Setup/PropertyUnitType' name='Property Unit Type' displayName='Property Unit Type' />
                  <ProtectedMenu to='/Setup/PropertyUsageType' name='Property Usage Type' displayName='Property Usage Type' />
                  <ProtectedMenu to='/setup/ReceivableAccounts' name='ReceivableAccounts' displayName='Receivable Accounts' />
                  <ProtectedMenu to='/TenantContractFS' name='Tenant Contract FS' displayName='Tenant Contract FS' />
              
                </ul>
              </li> */}
              
              {/* SETUP MENU END */}



              {/* SECURITY MENU START */}
              {/* <li className='nav-item'>
                <ProtectedSubmenu
                  displayValue='Security'
                  names={['User Information', 'Change Password', 'User Rights']}
                  type='mainmenu'
                  icon='fa-sitemap'
                />
                <ul className='nav nav-treeview'>
                  <ProtectedMenu to='/UsersInfo' name='User Information' displayName='Users' />
                  <ProtectedMenu to='/Security/ChangePassword' name='Change Password' displayName='Change Password' />
                  <ProtectedMenu to='/Security/ChangeAccess' name='User Rights' displayName='User Rights' />
                </ul>
              </li> */}
              {/* SECURITY MENU END */}

              {/* FINANCE MENU START */}
<li className='nav-item'>
                 <ProtectedSubmenu
          displayValue='Finance '
                    type='mainmenu'
                    names = { [`Receipt Voucher`,`Payment Voucher`,`Journal Voucher`]}

                    icon='fa-sitemap'
                    
                    />
                <ul className='nav nav-treeview'>
                   <li className='nav-item'>
                  <ProtectedSubmenu
                    displayValue='Journal Voucher'
                    names = { [`Journal Voucher`]}
                    type='submenu'
                    icon='nav-icon'
                    
                    />
                <ul className='nav nav-treeview'>

                  <ProtectedMenu
                    to='/Voucher/JV/Detail'
                    name='Journal Voucher'
                    displayName='Detail'
                  />
                  <ProtectedMenu
                    to='/Voucher/JV/Summary'
                    name='Journal Voucher'
                    displayName='Summary'
                  />
                  </ul>
                  </li>
                   <li className='nav-item'>
                  <ProtectedSubmenu
                    displayValue='Payment Voucher'
                    names = { [`Payment Voucher`]}
                    type='submenu'
                    icon='nav-icon'
                    
                    />
                <ul className='nav nav-treeview'>

                <ProtectedMenu
                    to='/Voucher/PV/Detail'
                    name='Payment Voucher'
                    displayName=' Detail'
                  />
                  <ProtectedMenu
                    to='/Voucher/PV/Summary'
                    name='Payment Voucher'
                    displayName=' Summary'
                  />
                  </ul>
                  </li>
                   <li className='nav-item'>
                  <ProtectedSubmenu
                    displayValue='Receipt Voucher'
                    names = { [`Receipt Voucher`]}
                    type='submenu'
                    icon='nav-icon'
                    
                    />
                <ul className='nav nav-treeview'>

                <ProtectedMenu
                    to='/Voucher/RV/Detail'
                    name='Receipt Voucher'
                    displayName='Detail'
                  />
                  <ProtectedMenu
                    to='/Voucher/RV/Summary'
                    name='Receipt Voucher'
                    displayName='Summary'
                  />
                  </ul>
                  </li>
                  
                  </ul>
                  </li>  
                  {/* FINANCE MENU END */}

              {/* ACCOUNTS MENU START */}
              {/* <li className='nav-item'>
                <ProtectedSubmenu
                  displayValue='Accounts '
                  names={['User Information']}
                  type='mainmenu'
                  icon='fa-bars'
                />
                <ul className='nav nav-treeview'>
                  <ProtectedMenu to='/Setup/Brand' name='User Information' displayName='Accounts ' />
                  <ProtectedMenu to='/ChartOfAccount' name='Chart Of Account' displayName='Chart Of Account ' />
                </ul>
              </li> */}
              {/* ACCOUNTS MENU END */}
            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
}
